import React from 'react';

const getPrimaryContent = ({ customerType, isEarlyCycle, isCheckedIn }) => {
  if (customerType === 'active' && isEarlyCycle) {
    return {
      eyebrowKey: 'Dashboard_Primary_Early_Eyebrow',
      titleKey: 'Dashboard_Primary_Early_Title',
      bodyKey: 'Dashboard_Primary_Early_Body',
      ctaKey: 'Dashboard_Primary_Early_Cta',
      action: 'howTo',
    };
  }

  if (customerType === 'active') {
    return {
      eyebrowKey: 'Dashboard_Primary_Active_Eyebrow',
      titleKey: 'Dashboard_Primary_Active_Title',
      bodyKey: 'Dashboard_Primary_Active_Body',
      ctaKey: isCheckedIn ? 'Dashboard_CheckedInToday' : 'Dashboard_Primary_Active_Cta',
      action: 'checkIn',
    };
  }

  if (customerType === 'oneOff') {
    return {
      eyebrowKey: 'Dashboard_Primary_OneOff_Eyebrow',
      titleKey: 'Dashboard_Primary_OneOff_Title',
      bodyKey: 'Dashboard_Primary_OneOff_Body',
      ctaKey: 'Dashboard_Primary_OneOff_Cta',
      action: 'subscription',
    };
  }

  return {
    eyebrowKey: 'Dashboard_Primary_Cancelled_Eyebrow',
    titleKey: 'Dashboard_Primary_Cancelled_Title',
    bodyKey: 'Dashboard_Primary_Cancelled_Body',
    ctaKey: 'Dashboard_Primary_Cancelled_Cta',
    action: 'reactivate',
  };
};

const DashboardPrimaryAction = ({
  customerType,
  isEarlyCycle,
  isCheckedIn,
  isCheckingIn,
  onCheckIn,
  onOpenHowTo,
  onReactivate,
  onSwitchToSubscription,
  t,
}) => {
  const content = getPrimaryContent({ customerType, isEarlyCycle, isCheckedIn });

  const handleClick = () => {
    if (content.action === 'checkIn') {
      onCheckIn();
      return;
    }

    if (content.action === 'howTo') {
      onOpenHowTo();
      return;
    }

    if (content.action === 'subscription') {
      onSwitchToSubscription();
      return;
    }

    onReactivate();
  };

  const isDisabled = content.action === 'checkIn' && (isCheckedIn || isCheckingIn);

  return (
    <section className="t-flex t-flex-col t-gap-6 t-rounded-[14px] t-bg-navy t-px-6 t-py-7 t-text-white md:t-flex-row md:t-items-center md:t-justify-between md:t-px-8">
      <div>
        <p className="t-m-0 t-mb-2 t-text-xs t-font-extrabold t-uppercase t-tracking-[0.08em] t-text-butter">
          {t(content.eyebrowKey)}
        </p>
        <h2 className="t-m-0 t-font-serif t-text-[26px] t-font-normal t-leading-tight t-text-white">
          {t(content.titleKey)}
        </h2>
        <p className="t-m-0 t-mt-3 t-max-w-[520px] t-text-sm t-leading-relaxed t-text-teal-bg">
          {t(content.bodyKey)}
        </p>
      </div>
      <button
        type="button"
        className="t-w-full t-rounded-full t-border-0 t-bg-butter t-px-6 t-py-3 t-text-sm t-font-extrabold t-text-navy disabled:t-cursor-not-allowed disabled:t-opacity-70 md:t-w-auto md:t-whitespace-nowrap"
        disabled={isDisabled}
        onClick={handleClick}
      >
        {isCheckingIn && content.action === 'checkIn' ? t('Dashboard_CheckingIn') : t(content.ctaKey)}
      </button>
    </section>
  );
};

export default DashboardPrimaryAction;
